var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCdmoCommercialIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_283_7594)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_283_7594",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 33C5 15.3269 19.3269 1 37 1C54.6731 1 69 15.3269 69 33C69 50.6731 54.6731 65 37 65C19.3269 65 5 50.6731 5 33Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5 33C5 15.3269 19.3269 1 37 1C54.6731 1 69 15.3269 69 33C69 50.6731 54.6731 65 37 65C19.3269 65 5 50.6731 5 33Z",
    fill: "#EDFAF3",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 33M69 33M69 33M5 33M37 1M69 33M37 65M5 33M37 65V63C20.4315 63 7 49.5685 7 33H5H3C3 51.7777 18.2223 67 37 67V65ZM69 33H67C67 49.5685 53.5685 63 37 63V65V67C55.7777 67 71 51.7777 71 33H69ZM37 1V3C53.5685 3 67 16.4315 67 33H69H71C71 14.2223 55.7777 -1 37 -1V1ZM37 1V-1C18.2223 -1 3 14.2223 3 33H5H7C7 16.4315 20.4315 3 37 3V1Z",
    fill: "#00A651",
    mask: "url(#path-1-inside-1_283_7594)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 42.7299C36.304 42.9054 36.6489 42.9979 37 42.9979C37.3511 42.9979 37.696 42.9054 38 42.7299L45 38.7299C45.3037 38.5545 45.556 38.3024 45.7315 37.9987C45.9071 37.6951 45.9996 37.3506 46 36.9999V28.9999C45.9996 28.6492 45.9071 28.3047 45.7315 28.0011C45.556 27.6974 45.3037 27.4453 45 27.2699L38 23.2699C37.696 23.0944 37.3511 23.002 37 23.002C36.6489 23.002 36.304 23.0944 36 23.2699L29 27.2699C28.6963 27.4453 28.444 27.6974 28.2685 28.0011C28.0929 28.3047 28.0004 28.6492 28 28.9999V36.9999C28.0004 37.3506 28.0929 37.6951 28.2685 37.9987C28.444 38.3024 28.6963 38.5545 29 38.7299L36 42.7299Z",
    stroke: "#00A651",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 43V33",
    stroke: "#00A651",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.29 28L37 33L45.71 28",
    stroke: "#00A651",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 25.27L41.5 30.42",
    stroke: "#00A651",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_283_7594",
    x: 0,
    y: 0,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_283_7594"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_283_7594"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_283_7594"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_283_7594",
    result: "effect2_dropShadow_283_7594"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_283_7594",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdmoCommercialIcon);
export default __webpack_public_path__ + "static/media/cdmo-Commercial-icon.aef8bbbf1d7d9974125652f54898b949.svg";
export { ForwardRef as ReactComponent };